import React from 'react';
import { Helmet } from 'react-helmet';

const TermsAndConditions = () => {
    return (
        <>
            <Helmet>
                <title>Terms & Conditions - CrikStars</title>
            </Helmet>
            <div className="p-4 max-w-5xl mx-auto">
                <h1 className="text-2xl md:text-3xl font-bold mb-4">Terms & Conditions – CrikStars</h1>

                <h2 className="text-xl font-semibold mt-4">Acceptance</h2>
                <p>By registering or using CrikStars, you agree to these Terms & Conditions.</p>

                <h2 className="text-xl font-semibold mt-4">Services Provided</h2>
                <p>CrikStars enables users to:</p>
                <ul className="list-disc list-inside">
                    <li>Create and manage teams and tournaments.</li>
                    <li>Score matches and view live updates.</li>
                    <li>Follow players, teams, and tournaments.</li>
                    <li>Receive notifications and promotional offers.</li>
                </ul>

                <h2 className="text-xl font-semibold mt-4">User Responsibilities</h2>
                <ul className="list-disc list-inside">
                    <li>Provide accurate account information.</li>
                    <li>Do not misuse the app for spamming, harassment, or fraudulent activities.</li>
                    <li>Respect other users’ content and privacy.</li>
                    <li>Maintain the security of your login credentials.</li>
                </ul>

                <h2 className="text-xl font-semibold mt-4">Content & Intellectual Property</h2>
                <p>All app content (logos, designs, software) belongs to CrikStars.</p>
                <p>User-generated content (e.g., team names, photos) remains user-owned, but by posting, you grant CrikStars a license to display it within the app.</p>

                <h2 className="text-xl font-semibold mt-4">Limitation of Liability</h2>
                <p>CrikStars is not responsible for:</p>
                <ul className="list-disc list-inside">
                    <li>Service interruptions due to technical issues.</li>
                    <li>Third-party links or advertisements.</li>
                    <li>Any financial loss due to user errors or misuse.</li>
                </ul>

                <h2 className="text-xl font-semibold mt-4">Account Suspension</h2>
                <p>We may suspend or terminate accounts violating these terms or applicable laws.</p>

                <h2 className="text-xl font-semibold mt-4">Payments & Subscriptions</h2>
                <ul className="list-disc list-inside">
                    <li>Some features may require paid subscriptions.</li>
                    <li>All payments are processed securely.</li>
                    <li>Refund policies will follow app store regulations.</li>
                </ul>

                <h2 className="text-xl font-semibold mt-4">Governing Law</h2>
                <p>These Terms are governed by the laws of India. Any disputes shall be handled in competent courts in [Your City, India].</p>

                <h2 className="text-xl font-semibold mt-4">Changes to Terms</h2>
                <p>We may update these terms. Continued use means you accept the updated version.</p>

                <h2 className="text-xl font-semibold mt-4">Contact Us</h2>
                <p>
                    For support or legal queries:
                    <a href="mailto:support@crikstars.com" className="text-primary-600 font-semibold hover:text-primary-700">{" "}support@crikstars.com</a>
                </p>
            </div>
        </>
    );
};

export default TermsAndConditions;
